<script>
export default {
  name: 'Break',
  functional: true,

  props: {
    size: {
      type: [Number, String],
      default: 1
    }
  },

  render: function (createElement, context) {
    return createElement('div', {
      'class': [
        'Break',
        `Break--size${context.props.size}`
      ]
    })
  }
}
</script>

<style>
@import 'properties';

.Break {
}

.Break--size0\.25 {
  padding-top: var(--unit-025);
}

.Break--size0\.5 {
  padding-top: var(--unit-025);

  @media (--large) {
    padding-top: var(--unit-05);
  }
}

.Break--size0\.75 {
  padding-top: var(--unit-05);

  @media (--large) {
    padding-top: var(--unit-075);
  }
}

.Break--size1 {
  padding-top: var(--unit-05);

  @media (--large) {
    padding-top: var(--unit);
  }
}

.Break--size1\.5 {
  padding-top: var(--unit-1);

  @media (--large) {
    padding-top: var(--unit-15);
  }
}

.Break--size2 {
  padding-top: var(--unit-15);

  @media (--large) {
    padding-top: var(--unit-2);
  }
}

.Break--size2\.5 {
  padding-top: var(--unit-2);

  @media (--large) {
    padding-top: var(--unit-25);
  }
}

.Break--size3 {
  padding-top: var(--unit-2);

  @media (--large) {
    padding-top: var(--unit-3);
  }
}
</style>



// WEBPACK FOOTER //
// Break.vue?743eb684